// extracted by mini-css-extract-plugin
export var button = "luas-stop-times-module-module--button--0ec45";
export var directionBlock = "luas-stop-times-module-module--directionBlock--e61ac";
export var directionName = "luas-stop-times-module-module--directionName--cddc2";
export var directions = "luas-stop-times-module-module--directions--473f7";
export var error = "luas-stop-times-module-module--error--4f489";
export var loading = "luas-stop-times-module-module--loading--68678";
export var main = "luas-stop-times-module-module--main--36e37";
export var message = "luas-stop-times-module-module--message--5896c";
export var page = "luas-stop-times-module-module--page--89a62";
export var sidebar = "luas-stop-times-module-module--sidebar--db50e";
export var sidebarTitle = "luas-stop-times-module-module--sidebarTitle--57c5b";
export var stopName = "luas-stop-times-module-module--stopName--b9788";
export var table = "luas-stop-times-module-module--table--0afeb";
export var tableWrapper = "luas-stop-times-module-module--tableWrapper--3a670";